import { FunctionComponent } from 'react';

// @Component
import Image from '@Components/Utils/Image';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// NPM
import classnames from 'classnames';

// scss
import styles from './Empty.module.scss';

interface EmptyProps {
    title?: string;
    subTitle?: string;
}

const Empty: FunctionComponent<EmptyProps> = ({ title, subTitle }) => {
    const { deviceType } = useViewDetected();

    const classNameEmpty = classnames([
        styles.wrapper_empty,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    return (
        <div className={classNameEmpty}>
            <Image src="/assets/cong_dong/empty.png" width={'378px'} height={'249px'} />
            <div className={styles.title}>{title}</div>
            <div className={styles.subTitle}>{subTitle}</div>
        </div>
    );
};

Empty.defaultProps = {
    title: 'Tìm kiếm không có kết quả!',
    subTitle: 'Xin lỗi chúng tôi không tìm thấy kết quả phù hợp với bạn.',
};

export default Empty;
